import { monthNames } from './typeConstants';

export type dateType = string | number | Date;

export const setDateFormat = (date?: Date) => {
    if (date)
        return new Date(date).toLocaleString('en-US', {
            dateStyle: 'medium',
        });

    return new Date().toLocaleString('en-US', {
        dateStyle: 'medium',
    });
};

export const formatDateMMDDYYYY = (date: dateType) => {
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();

    return [month.toString().padStart(2, '0'), day.toString().padStart(2, '0'), year].join('/');
};

export const formatDateISO8601 = (date: dateType) => {
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();

    const mm = month.length < 2 ? '0' + month : month;
    const dd = day.length < 2 ? '0' + day : day;

    return [year, mm, dd].join('-');
};

// this function use to convert Apr 08, 2023 to 08-Apr-2023 formate
export const changeDateFormate = (date: dateType) => {
    const today = new Date(date);
    const yyyy = today.getFullYear();
    let dd: number | string = today.getDate();
    if (dd < 10) dd = '0' + dd;
    return dd + '-' + monthNames[today.getMonth() + 1] + '-' + yyyy;
};

export function dayTimeFormat(input: string) {
    const utcDate = new Date(input);
    const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(utcDate);

    // Get hours and minutes (e.g., "1:30 PM")
    const time = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    }).format(utcDate);
    return `${dayOfWeek}, ${time}`;
}

// this function use to convert dd-mm-yyy to 01-Feb-2023 formate
export function formatDate(inputDate: string) {
    const parts = inputDate.split('-');

    const day = parts[0];
    const monthIndex = parseInt(parts[1], 10); // Subtract 1 as months are zero-indexed
    const month = monthNames[monthIndex];
    const year = parts[2];

    return `${day}-${month}-${year}`;
}

export function convertUTCtoCustomShortFormat(utcDateString: string) {
    const utcDate = new Date(utcDateString);

    // Get month abbreviation and day with leading zero (e.g., "Mar 01")
    const formattedDate = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: '2-digit',
    }).format(utcDate);

    // Get year (e.g., "2023")
    const year = utcDate.getFullYear();

    return `${formattedDate}, ${year}`;
}
// this function use to convert dd-mm-yyy("07/14/2023 10:50:47") to 01-Feb-2023("14-Jul-2023") formate
export function formatDate2(datetime: string) {
    let date = ``;
    if (datetime !== undefined) {
        const [datePart] = datetime.split(' ');
        const [month, day, year] = datePart.split('/');
        const monthIndex = parseInt(month, 10);
        const formattedMonth = monthNames[monthIndex];
        date = `${day}-${formattedMonth}-${year}`;
    }
    return date;
}

export const formatDate3 = (datetime: dateType) => {
    // ----------old formate commented---------
    const date = new Date(datetime);

    const year = date.getFullYear();
    const monthIndex = String(date.getMonth() + 1).padStart(2, '0');
    const month = monthNames[parseInt(monthIndex, 10)];
    const day = String(date.getDate()).padStart(2, '0');

    const dateString = `${day}-${month}-${year}`;
    return dateString;
};
// this function use to convert dd-mm-yyy("2023-07-14T10:50:47") to 01-Feb-2023("14-Jul-2023") formate
export function formatDate4(datetime: string) {
    let date = ``;
    if (datetime !== undefined) {
        const datePart = datetime.split('T')[0];
        const [year, month, day] = datePart.split('-');
        const monthIndex = parseInt(month, 10);
        const formattedMonth = monthNames[monthIndex];
        date = `${day}-${formattedMonth}-${year}`;
    }
    return date;
}

export const getPreviuosDate = (givenDate: any) => {
    if (givenDate !== null) {
        const previousDate = new Date(givenDate?.getTime()); // Create a new date object based on the given date
        return new Date(previousDate.setDate(givenDate.getDate() - 1)); // Set the previous date by subtracting 1 from the current date
    } else {
        return null;
    }
};

export const getNextDate = (givenDate: any) => {
    if (givenDate !== null) {
        const nextDate = new Date(givenDate?.getTime()); // Create a new date object based on the given date
        return new Date(nextDate.setDate(givenDate.getDate() + 1)); // Set the next date by adding 1 to the current date
    } else {
        return null;
    }
};

// this function change date formate from date time to date like 08-Aug-2023
export const datetimeToDate = (datetime: dateType) => {
    // ----------old formate commented---------
    const date = new Date(datetime);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const dateString = `${year}-${month}-${day}`;
    return dateString;
};

export const getChangeDateFormate = (date: Date) => {
    const dateString = date;
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();

    const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
    return formattedDate;
};

export const getMonthName = (month: number) => {
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    return monthNames[month - 1];
};
export function convertUTCtoDateTimeFormat(utcDateString: string) {
    const utcDate = new Date(utcDateString);

    const year = utcDate.getFullYear();
    const day = utcDate.getDate().toString().padStart(2, '0'); // Add leading zero to day
    const fullMonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(utcDate);

    const time = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    }).format(utcDate);
    const dateString = `${day}-${fullMonth}-${year}. ${time}`;
    return dateString;
}

export function getDataTimeString() {
    const d = new Date();
    const date = d.toISOString().split('T')[0];
    const time = d.toTimeString().split(' ')[0];
    return `${date}-${time}`;
}

export const formatDateWithOrdinal = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '--';
  
  const date = new Date(dateStr);
  const day = date.getDate();
  
  const getOrdinalSuffix = (n: number) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const month = date.toLocaleDateString('en-US', { month: 'long' });
  const year = date.getFullYear();

  return `${month} ${getOrdinalSuffix(day)}, ${year}`;  // → "April 1st, 2026"
};
